import { CommsAgencyChat } from '@/features/comms/screens/CommsAgencyChat';
import { isSupabaseCommsEnabled } from '@/features/comms/lib/config';

import PubnubInappChat from './Pubnub';

const InappChat = () => {
  return isSupabaseCommsEnabled() ? <CommsAgencyChat /> : <PubnubInappChat />;
};

export default InappChat;
